import { ref, computed } from 'vue'
import axios from 'axios'
import { defineStore } from 'pinia'

import {
  crossAnalysisTypes,
  periods,
} from '../../../modules/analysis'

export interface Date {
  id: string
  name: string
}
interface Field {
  key: string
  id: string
  uuid: string
  value: number
  name: string
}
export interface RawAgg {
  counts: number
  counts_without_rating_null: number
  totalCounts: number
  scores: number
  fields: Field[]
  totalScores: string
  storeNames?: Store[]
}
interface AggsParams {
  analysis_axis: string
}
export interface PageType {
  id: string
  name: string
  fields: string
}
interface Param {
  posted_at_term: string
}
interface Payload {
  companyUuid: string
  params: Param
}
export interface AnalysisAxe {
  id: string
  name: string
  fields: string
  allName: string
}
interface Field {
  id: string
  key: string
  name: string
  uuid: string
  value: number
}
interface Store {
  name: string
  uuid: string
}
interface Attribute {
  posted_count: number
  posted_count_without_rating_null: number
  total_posted_count: number
  average_score: number
  fields: Field[]
  total_score: string
  store_names?: Store[]
}
interface ScatterData {
  attributes: Attribute
  id: string
  type: string
}
interface ScatterMeta {
  review_count: number
}

export const useScatterStore = defineStore('scatter', () => {
  const rawAggs = ref<RawAgg[]>([])
  const aggsLoading = ref<boolean>(false)
  const date = ref<Date>(periods[1])
  const pageType = ref<PageType>(crossAnalysisTypes[0])
  const filteredCount = ref<number>(0)

  const prepareConnect = () => {
    aggsLoading.value = true
    rawAggs.value = []
  }
  const stopConnect = () => {
    aggsLoading.value = false
  }

  const readScattersSuccess = (data: ScatterData[]) => {
    rawAggs.value = data.map((v: ScatterData) => {
      const attributes = v.attributes
      return {
        // ここの key は reviewDataTypes の id と合わせること
        counts: attributes.posted_count,
        counts_without_rating_null: attributes.posted_count_without_rating_null,
        totalCounts: attributes.total_posted_count,
        scores: attributes.average_score,
        fields: attributes.fields,
        totalScores: attributes.total_score,
        storeNames: attributes.store_names,
      }
    })
    stopConnect()
  }
  const setMeta = (meta: ScatterMeta) => {
    filteredCount.value = meta.review_count
  }
  const aggsParams = computed<AggsParams>(() => {
    return {
      analysis_axis: pageType.value.fields,
    }
  })

  const readScatters = (payload: Payload) => {
    const { companyUuid, params } = payload
    prepareConnect()
    return axios
      .post(`/api/companies/${companyUuid}/analysis/scatters`, {
        ...aggsParams.value,
        ...params
      })
      .then(res => {
        readScattersSuccess(res.data.data)
        setMeta(res.data.meta)
      })
      .catch(err => {
        stopConnect()
        console.error('error', err)
      })
  }

  const setPageType = (analysisAxes: AnalysisAxe[], queryElement: string) => {
    const type = analysisAxes.find(v => v.fields === queryElement)
    if (type === undefined) return
    pageType.value = type
  }

  return { rawAggs, aggsLoading, date, pageType, filteredCount, readScatters, setPageType }
})
